import axios from 'axios';
import { API_BASE_URL } from '../../config/apiConfig';

// ==============================================
// OPEN FD VERIFICATION
// Legacy: /AccountsApproval/VerifyOpenFD (+ VerifyOpenFDGrid / VerifyOpenFDView)
// ==============================================

const headers = { 'Content-Type': 'application/json' };

const handle = (error) => {
    if (error.response?.data) throw error.response.data;
    throw error;
};

// Queue — newly opened FDs pending at this role's level.
export const getVerificationOpenFDs = async (roleId) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/Accounts/GetVerificationOpenFD`, { params: { Roleid: roleId }, headers });
        return response.data;
    } catch (error) { return handle(error); }
};

// Detail of one FD by its bank transaction ref no (carries MOID, bank, payment details).
export const getOpenFDByTransNo = async (transactionNo) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/Accounts/GetOpenFDbyTransno`, { params: { Transactionno: transactionNo }, headers });
        return response.data;
    } catch (error) { return handle(error); }
};

// Bank dropdown for the returned-FD resubmit form.
export const getBanks = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/Accounts/GetBankDetails`, { headers });
        return response.data;
    } catch (error) { return handle(error); }
};

// Verify / Approve / Reject (spApproveOpenFD — success literal "Submitted").
export const approveOpenFD = async (payload) => {
    try {
        const response = await axios.put(`${API_BASE_URL}/Accounts/ApproveOpenFD`, payload, { headers });
        return response.data;
    } catch (error) { return handle(error); }
};

// Resubmit a returned FD (spOpenFD with Action 'Update' — success literal "Updated").
export const updateOpenFD = async (payload) => {
    try {
        const response = await axios.put(`${API_BASE_URL}/Accounts/UpdateOpenFD`, payload, { headers });
        return response.data;
    } catch (error) { return handle(error); }
};
